export class EmcSearchOutput {
    searchValue: string ="";
    attributeDefinitionId: number | null | undefined = null;
    staticPropertyName: string |undefined = '';
}